import { ClipboardCheck, MapPin, FileSearch, Banknote, Wrench, BarChart3 } from "lucide-react";

const steps = [
  { n: "01", icon: ClipboardCheck, title: "Analyse d'éligibilité", desc: "Étude rapide de votre site et de vos projets au regard du catalogue CEE pour identifier les opérations finançables." },
  { n: "02", icon: MapPin, title: "Visite technique", desc: "Nos ingénieurs se rendent sur site pour relever les paramètres clés et confirmer le potentiel d'économies." },
  { n: "03", icon: FileSearch, title: "Étude énergétique", desc: "Un bureau d'études dédié dimensionne les actions, valide la performance attendue et chiffre les gains." },
  { n: "04", icon: Banknote, title: "Validation du financement CEE", desc: "Nous montons votre dossier, sélectionnons l'obligé, sécurisons la valorisation et formalisons l'offre." },
  { n: "05", icon: Wrench, title: "Installation", desc: "Pilotage des travaux par nos partenaires certifiés RGE, contrôle qualité et conformité réglementaire." },
  { n: "06", icon: BarChart3, title: "Mesure des économies", desc: "Vérification IPMVP, monitoring et rapport annuel — nous prouvons les économies année après année." },
];

export default function MethodTimeline() {
  return (
    <section data-testid="method-timeline" className="relative bg-white">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-10 py-24 md:py-32">
        <div className="grid md:grid-cols-12 gap-10 mb-16 md:mb-20 items-end">
          <div className="md:col-span-7">
            <div className="text-[11px] font-semibold tracking-[0.28em] text-[#10B981] uppercase mb-5">Notre méthode</div>
            <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-[#0F172A] tracking-tight text-balance leading-[1.05]">
              Une méthode éprouvée, de l&apos;éligibilité à la mesure des économies.
            </h2>
          </div>
          <div className="md:col-span-5 text-[#475569] md:text-lg leading-relaxed">
            Six étapes orchestrées par un interlocuteur unique. Vous restez focalisé sur votre cœur
            de métier, nous gérons tout le reste.
          </div>
        </div>

        <ol className="relative grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {/* vertical line decoration on desktop */}
          <div aria-hidden className="hidden lg:block absolute inset-y-6 left-1/2 -translate-x-1/2 w-px bg-gradient-to-b from-transparent via-[#10B981]/30 to-transparent" />
          {steps.map((s, i) => (
            <li
              key={s.n}
              data-testid={`method-step-${i + 1}`}
              className="group relative bg-white rounded-2xl border border-black/[0.06] p-7 transition-all hover:border-[#10B981]/40 hover:shadow-[0_24px_60px_-30px_rgba(16,185,129,0.35)] hover:-translate-y-1"
            >
              <div className="flex items-start justify-between mb-6">
                <div className="h-12 w-12 rounded-xl bg-[#10B981]/10 grid place-items-center text-[#064E3B] group-hover:bg-[#10B981] group-hover:text-white transition-colors">
                  <s.icon className="h-5 w-5" strokeWidth={1.75} />
                </div>
                <span className="font-display text-3xl font-bold text-[#10B981]/25 group-hover:text-[#10B981]/60 transition-colors">{s.n}</span>
              </div>
              <h3 className="font-display text-xl font-semibold text-[#0F172A] mb-2">{s.title}</h3>
              <p className="text-sm text-[#475569] leading-relaxed">{s.desc}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
